import React from "react";

const RadioButton = ({ id, name, label, value, onChange, selectedOption }) => {
  return (
    <label htmlFor={`${id}`} className="flex items-center gap-5 cursor-pointer">
      <input
        type="radio"
        id={`${id}`}
        name={`${name}`}
        value={value}
        onChange={onChange}
        checked={selectedOption === value}
        className="cursor-pointer accent-[#AB3C1B]"
      />
      <label
        htmlFor={`${id}`}
        className="cursor-pointer font-lato text-[1rem] font-bold"
      >
        {label}
      </label>
    </label>
  );
};

export default RadioButton;
